



























import BaseComponent from "@/asdcom/BaseComponent";
export default class Error403View extends BaseComponent {
  created() {
    abp.log.debug({ "error-403.vue ": "created" });
    // this.loadCss("https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css","sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T");
  }
}
